import { Typography } from '@mui/material'
import { memo, useContext } from 'react'
import tw from 'twin.macro'
import EmptyImage from 'src/assets/images/empty-clipboard.svg'
import EmptySearchImage from 'src/assets/images/empty-search.svg'
import { colors } from 'src/theme'
import { SubcontractorRequestsTableContext } from './SubcontractorRequestsTable.context'

const EmptySubcontractorRequestsComponent = () => {
  const { searchQuery, masterContractorFilter } = useContext(SubcontractorRequestsTableContext)

  const isSearchUsed = Boolean(searchQuery || masterContractorFilter.length)

  return (
    <div css={tw`flex flex-1 h-full justify-center items-center flex-col`}>
      <img src={isSearchUsed ? EmptySearchImage : EmptyImage} />
      <Typography css={tw`mb-1 mt-2 w-[270px] text-center`} variant="h4" fontWeight={600}>
        {isSearchUsed ? 'No requests found' : 'This board is empty'}
      </Typography>
      <Typography css={tw`w-[270px] text-center`} color={colors.SHADES_GREY_400} variant="body2">
        {isSearchUsed
          ? 'Please try a different search query or filters.'
          : "You haven't received any requests yet."}
      </Typography>
    </div>
  )
}

export const EmptySubcontractorRequests = memo(EmptySubcontractorRequestsComponent)
